import Nullstack from 'nullstack';
export default function IconLego({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-lego",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "9.5",
    y1: "11",
    x2: "9.51",
    y2: "11"
  }), "   ", Nullstack.element("line", {
    x1: "14.5",
    y1: "11",
    x2: "14.51",
    y2: "11"
  }), "   ", Nullstack.element("path", {
    d: "M9.5 15a3.5 3.5 0 0 0 5 0"
  }), "   ", Nullstack.element("path", {
    d: "M7 5h1v-2h8v2h1a3 3 0 0 1 3 3v9a3 3 0 0 1 -3 3v1h-10v-1a3 3 0 0 1 -3 -3v-9a3 3 0 0 1 3 -3"
  }), " ");
}